import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Globals } from '../objects/Globals';
import { EnvService } from '../env.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../objects/Globals";
import * as i3 from "../env.service";
var InputService = /** @class */ (function () {
    function InputService(http, globals, env) {
        this.http = http;
        this.globals = globals;
        this.env = env;
        this.serviceUrl = this.env.servicePath;
    }
    InputService.prototype.changeInputValue = function (id, value) {
        var path = this.serviceUrl + "ChangeInputValue/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, value, httpOptions);
    };
    InputService.prototype.executeInputWorkflow = function (id) {
        var path = this.serviceUrl + "ExecuteInputWorkflow/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    InputService.ngInjectableDef = i0.defineInjectable({ factory: function InputService_Factory() { return new InputService(i0.inject(i1.HttpClient), i0.inject(i2.Globals), i0.inject(i3.EnvService)); }, token: InputService, providedIn: "root" });
    return InputService;
}());
export { InputService };
